<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'md'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="px-3">
      <div class="row mx-0 px-0">
        <div class="mb-2 col-xl-12 px-1">
          <label class="form-label">Código</label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="data_detail.code"
            placeholder="Ej: ALM-001"
            style="text-transform: uppercase"
          />
        </div>
        <div class="mb-2 col-xl-12 px-1">
          <label class="form-label">Nombre</label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="data_detail.name"
            placeholder="Ej: MEDICAMENTOS"
            style="text-transform: uppercase"
          />
        </div>
      </div>

      <!-- Switch estado solo en edición -->
      <div class="col-md-12 mt-3 pt-1" v-if="num === 1">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="switchAlmacenPrincipal"
            v-model="data_detail.state"
            :true-value="1"
            :false-value="0"
          />
          <label class="form-check-label" for="switchAlmacenPrincipal">
            {{ data_detail.state == 1 ? "Activo" : "Inactivo" }}
          </label>
        </div>
      </div>
    </div>

    <template #footer>
      <button
        class="btn btn-success btn-sm"
        @click="DataDetail"
        :disabled="cpButton"
      >
        {{ num == 0 ? "Registrar" : "Editar" }}
      </button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import { mapActions } from "vuex";

export default {
  name: "c-modal-almacen-principal",
  components: { CModal },
  props: {
    title: String,
    boo_modal: Boolean,
    num: Number,
    payload: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      data_detail: {
        code: "",
        name: "",
        state: 1,
        almacen_id: "1",
      },
    };
  },
  watch: {
    payload: {
      handler(newVal) {
        if (this.num == 1 && newVal) {
          this.data_detail = { ...newVal };
        } else {
          this.data_detail = { code: "", name: "", state: 1, almacen_id: "1" };
        }
      },
      immediate: true,
    },
  },
  computed: {
    cpButton() {
      return !(this.data_detail.code != "" && this.data_detail.name != "");
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.data_detail = { code: "", name: "", state: 1, almacen_id: "1" };
      this.$emit("closeModal");
    },
    DataDetail() {
      this.$emit("Datadetail", this.data_detail, this.num);
      this.mtdClose();
    },
  },
};
</script>